import type { StyleRule } from '@archipro-design/aria';
import { buttonClassName } from '@archipro-design/aria';

/**
 * The form for the tag being placed. Pointer events are taken back from the shell, which
 * takes none: without them a press falls through onto the placement surface underneath and
 * re-drops the pin instead of reaching the form.
 */
export const NewTagModal: StyleRule = () => ({
    pointerEvents: 'auto',
});

export const CurrentTag: StyleRule = () => ({
    [`&.${buttonClassName}`]: {
        position: 'absolute',
    },
});

/**
 * Wrapper for the new-tag placement icon. Applies a `drop-shadow` filter for contrast on bright
 * photos; the shadow follows the tag glyph's painted bounds.
 */
export const TagIconOnPhoto: StyleRule = () => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.35))',
});
